import { defineMessages } from "react-intl";

export const ReplenishmentUnknownErrorDescription = defineMessages({
  UnknownError: {
    id: "replenishment.entity.error.unknown",
    defaultMessage: "Unknown error",
  },
});

export const ReplenishmentOrderErrorMessages = defineMessages({
  CardTitle: {
    id: "replenishment.order.failure.card.title",
    defaultMessage: "A shipping plan could not be generated",
  },
  CardDescription: {
    id: "replenishment.order.failure.card.description",
    defaultMessage: "Review and fix the following issues or remove the affected products, then try again.",
  },
  OrderErrorTitle: {
    id: "replenishment.order.failure.orderError.title",
    defaultMessage: "Order errors",
  },
  OrderItemErrorTitle: {
    id: "replenishment.order.failure.itemErrors.title",
    defaultMessage: "Products with errors",
  },
  ErrorResolutionDescription: {
    id: "replenishment.order.failure.resolution.description",
    defaultMessage: "A short description about how to resolve the issue. {learnMore}",
  },
  errorCode: {
    id: "replenishment.order.failure.errorCode",
    defaultMessage: "Error code received from channel: {errorCode}",
  },
});
